<script lang="ts" setup>
	defineProps<{
		title: string
		description: string
	}>()
</script>
<template>
	<div
		class="max-w-[565px] custom-transition snap-center md:mx-auto md:py-[150px] w-full flex-col md:items-start gap-5 md:gap-12 md:relative"
	>
		<div class="px-5 w-full md:px-0 space-y-7 md:space-y-8">
			<strong class="text-base-primary block sm:text-[2em] text-xl font-bold sm:leading-[38.40px]">
				{{ title }}
			</strong>

			<div class="self-stretch text-white sm:text-2xl text-base font-normal sm:leading-9" v-html="description" />
		</div>

		<slot />
	</div>
</template>

<style></style>
